import xhr from 'xhr';
import ApplicationDispatcher from '../../dispatcher/ApplicationDispatcher.js';
import ApiUtils from '../../utils/ApiUtils.js';
import MetadataActions from '../../metadata/flux/MetadataActions.js';
import WorkspaceConstants from './WorkspaceConstants.js';
import SnackBus from './SnackbarBus';
import snacks from './snacks';


export default {
    toggleModalWithIntent: function (type, target) {
        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.MODAL_TOGGLE,
            data: type
        });

        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.INTENT_INITIALIZE,
            data: {
                type: type,
                target: target
            }
        });
    },

    cancelModal: function (type) {
        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.MODAL_CANCEL,
            data: type
        });

        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.INTENT_CANCEL,
            data: type
        });
    },

    resolveIntent: function (value, type) {
        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.INTENT_RESOLVE,
            data: {
                type: type,
                value: value
            }
        });
    },

    toggleContextMenu: function () {
        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.CONTEXT_TOGGLE,
            data: null
        });
    },

    toggleOverlay: function (hasOverlay) {
        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.OVERLAY_TOGGLE,
            data: hasOverlay
        });
    },

    toggleCreatedEventModal: function (resp) {
        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.TOGGLE_CREATED_EVENT_MODAL,
            data: resp
        });
    },



    /*
        Uploads
     */
    toggleUploadModal: function (eventID) {
        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.UPLOAD_MODAL_TOGGLE,
            data: eventID
        });
    },

    addAssetUpload: function (payload) {
        ApplicationDispatcher.handleServerAction({
            actionType: WorkspaceConstants.UPLOAD_ADD,
            data: payload
        });
    },

    assetUploadProgress: function (payload) {
        ApplicationDispatcher.handleServerAction({
            actionType: WorkspaceConstants.UPLOAD_PROGRESS,
            data: payload
        });
    },

    finshedAssetUpload: function (payload) {
        // Splice the upload from the Store
        ApplicationDispatcher.handleServerAction({
            actionType: WorkspaceConstants.UPLOAD_FINISHED,
            data: payload
        });

        // Get the new assets listing for the Event
        if (payload.uploadJson.operation === 'upload') {



            var url = ApiUtils.buildReadUrl('Console', 'getEventsList');
            var eventID = payload.uploadJson.eventID;
            xhr.post(url, {
                body: JSON.stringify({
                    clientID: payload.uploadJson.clientID,
                    eventID: eventID,
                    showMediaAssets: true,
                    includePrivate: true
                })
            }, function (status, response, body) {
                if (!status) {
                    MetadataActions.fetchedAssets(JSON.parse(body));
                } else {
                    console.error(status);
                    console.error(response);
                    // @TODO Toast
                    SnackBus.emitError(snacks.errors.upload(response.statusMessage));
                }
            });
        } else if (payload.uploadJson.operation == 'misc') {
            MetadataActions.refetch();
        }
    },



    /*
        Client Message Actions
     */
    fetchedMessages: function (response) {
        ApplicationDispatcher.handleServerAction({
            actionType: WorkspaceConstants.MESSAGES_FETCHED,
            data: response
        });
    },

    toggleMessageCenter: function () {
        ApplicationDispatcher.handleServerAction({
            actionType: WorkspaceConstants.MESSAGES_TOGGLE,
            data: null
        });
    },

    openMesssageCenterTab: function (tab) {
        ApplicationDispatcher.handleServerAction({
            actionType: WorkspaceConstants.MESSAGES_OPEN_TAB,
            data: tab
        });
    },

    markMessageAsRead: function (type, id) {
        ApplicationDispatcher.handleServerAction({
            actionType: WorkspaceConstants.MESSAGES_MARK,
            data: {
                type: type,
                id: id
            }
        });
    },
    /**
     * @TODO DOCs
     * - php Session
     * - socket close/err
     *
     * @method
     * @param  {[type]} actionType [description]
     * @return {[type]}
     */
    haltApplication: function (data) {
        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.APPLICATION_HALT,
            data: data
        });
    },

    resumeApplication: function () {
        ApplicationDispatcher.handleViewAction({
            actionType: WorkspaceConstants.APPLICATION_RESUME,
            data: null
        });
    }
};
